export const LOGIN_SUCCESS = "LOGIN_SUCCESS";

export const setRegToken = (token) => ({
  type: "SET_REGTOKEN",
  payload: {
    token,
  },
});
export const setEmployeydata = (employeedata) => ({
  type: "SET_EMPLOYEE_DATA",
  payload: {
    employeedata,
  },
});
